<template>
    <div :class="['avatar-tip', align]" @click="showTip = !showTip" @mouseleave="showTip = false">
        <span class="label">{{ label }}</span>
        <transition name="avatar-tip-bounce">
            <div class="tip-box" v-if="showTip">
                <div class="tip-body">
                    <slot></slot>
                </div>
                <div class="avatar">
                    <img src="@/assets/img/avatars/teach.png" />
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'avatar-tip',
    props: {
        label: {
            Type: String,
            default: null,
        },
        tip: {
            Type: String,
            default: null,
        },
        align: {
            Type: String,
            default: 'left',
        },
    },
    computed: {},
    data() {
        return {
            showTip: false,
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.avatar-tip {
    position: relative;
    display: inline-block;
    margin: 0 0 0 10px;

    > .label {
        display: inline-block;
        background-color: #e2e1f9;
        color: $main-color;
        line-height: 30px;
        padding: 0 10px;
        border-radius: 10px;
        font-size: 10pt;
        transition: 0.2s;
        cursor: pointer;

        &:hover {
            background-color: #e2e1f9;
        }
    }

    .tip-box {
        position: absolute;
        bottom: 30px;
        padding: 0 0 15px 0;
        min-width: 320px;
        right: 0;
        text-align: left;
        z-index: 999999;

        > .tip-body {
            position: relative;
            display: block;
            color: #fff;
            background-color: #4b47c6;
            border-radius: 20px;
            line-height: 150%;
            font-weight: bold;
            font-size: 11pt;
            padding: 18px 95px 18px 18px;
            box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.2);
        }

        > .avatar {
            position: absolute;
            bottom: 0;
            right: 5px;
            width: 90px;

            > img {
                display: block;
                width: 100%;
                image-rendering: -webkit-optimize-contrast;
            }
        }
    }

    &.right {
        .tip-box {
            left: 0px;
            right: unset;

            > .tip-body {
                left: 10px;
                padding: 18px 18px 18px 95px;
            }

            > .avatar {
                left: 5px;
                right: unset;
                transform: scaleX(-1);
            }
        }
    }
}

.avatar-tip-bounce-enter-active {
    animation: avatar-tip-bounce-in 0.5s;
}

.avatar-tip-bounce-leave-active {
    animation: avatar-tip-bounce-in 0.5s reverse;
}

@keyframes avatar-tip-bounce-in {
    0% {
        transform: translateY(10px);
        opacity: 0;
    }

    50% {
        transform: translateY(-10px);
        opacity: 1;
    }

    100% {
        transform: translateY(0);
    }
}
</style>
